import { feSidebarAppointmentChange, feSidebarAppointmentClear, feSidebarAppointmentClearAndChange, feSidebarClose, feSidebarNavigateToAppointment, feSidebarOpen } from 'actions/ui.actions';
import { fromAnyToMessageCount } from 'bl/messages/conversion.bl';
import SP, { APPOINTMENT_SIDE_PANEL } from 'constants/ui/sidePanel.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import logger from 'utils/logger.util';
import isEnumVal from 'utils/predicates/enum/isEnumVal.util';
import isNotEnumVal from 'utils/predicates/enum/isNotEnumVal.util';
import { isValidId } from 'utils/predicates/fields.util';

const L = logger('appointmentSidebarReducer'); // eslint-disable-line no-unused-vars

const reduceClear = (state, action) => {
  const panel = action?.data?.panel;

  if (action?.data?.full) return {};

  const trimmedPanel = fromAnyToTrimmed(panel);
  const enumeration = APPOINTMENT_SIDE_PANEL;
  if (trimmedPanel && null !== state?.[trimmedPanel] && isEnumVal(enumeration, trimmedPanel)) {
    return { ...state, [trimmedPanel]: null };
  }

  L.warn('()', action?.ATAG, 'Invalid panel:', panel, '(', trimmedPanel, ') in', enumeration);
  return state;
};

const reduceChange = (state, action) => {
  const data = action?.data;

  const panel = fromAnyToTrimmed(data?.panel);

  if (!panel || isNotEnumVal(APPOINTMENT_SIDE_PANEL, panel)) {
    L.warn('()', action?.ATAG, 'Invalid panel:', panel);
    return state;
  }

  if (panel === SP.smsLog) {
    const panelState = state?.[SP.smsLog];
    const smsInput = fromAnyToString(data?.note ?? data?.smsInput);

    return {
      ...state,
      clientId: data?.clientId ?? state.clientId,
      [SP.smsLog]: {
        ...(panelState ?? {}),
        isSmsInputDirty: fromAnyToBool(smsInput),
        isEditMode: fromAnyToBool(data?.isEditMode ?? panelState?.isEditMode),
        messageCount: fromAnyToMessageCount(smsInput),
        smsInput,
        smsMessageSource: data?.source,
        updatedAt: fromAnyDateToIso(data?.updatedAt) || panelState?.updatedAt,
      },
    };
  }

  return state;
};

const reduceClose = (state) => (null === state?.appointmentId ? state : { ...state, appointmentId: null });

const reduceOpen = (state, action) => {
  const appointmentId = isValidId(action?.data?.appointmentId) ? action?.data?.appointmentId : state?.appointmentId;

  return true === state?.open && appointmentId === state?.appointmentId ? state : { ...state, open: true, appointmentId };
};

const reduceClearAndChange = (state, action) => {
  const s = reduceChange(reduceClear(state, action), action);
  L.debug('()', action, '+', state, '->', s);
  return s;
};

const MAP = Object.freeze({
  [feSidebarOpen.AT.name]: reduceOpen,
  [feSidebarNavigateToAppointment.AT.name]: reduceOpen,
  [feSidebarClose.AT.name]: reduceClose,

  [feSidebarAppointmentChange.AT.name]: reduceChange,
  [feSidebarAppointmentClear.AT.name]: reduceClear,
  [feSidebarAppointmentClearAndChange.AT.name]: reduceClearAndChange,
});

const appointmentSidebarReducer = (state, action) => (MAP[action?.type] ?? alwaysSame)(state ?? {}, action ?? {});

export default appointmentSidebarReducer;
